<template>
    <project-actor-dialog-list-table :data="getData" />
</template>

<script>
import ProjectActorDialogListTable from '@/components/Project/Dialogs/ProjectActorDialog/ProjectActorDialogListTable';

export default {
    name: 'ProjectActorDialogShrotlist',

    components: { ProjectActorDialogListTable },

    props: {
        actor: {
            type: Object,
            required: true,
        },
    },

    computed: {
        getData() {
            return this.actor.nominations.filter((item) => !item.contract_id) || [];
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectActorDialogShrotlist'] {
}
</style>
